import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import VueClipboard from 'vue-clipboard2'
import './assets/css/theme/index.css'
import './assets/css/theme/descriptions.css'
import './assets/css/theme/descriptions-item.css'
import utils from '@/utils/utils'
import { routeList } from "@utils/sideList"

Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.config.productionTip = false

Vue.prototype.$utils = utils
Vue.prototype.$routeList = routeList


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js